/**
 * Staff names offered in pickers. Both the phone form and the desktop
 * workspace read the pickup team from here; the phone form still keeps its
 * own evaluator options inline.
 */
export const EVALUATORS = ['Anders Melin', 'Jan Öberg', 'Peter Webb', 'Ilona Sweder'];

export const TEAM_MEMBERS = ['Peter Webb', 'Amos Fisk', 'Patrik Collén', 'Niklas Sköld'];
